module.exports = __webpack_public_path__ + "static/img/f-icon022.983bc92.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/f-icon022.png
// module id = 2mpp
// module chunks = 10